{% block ecocode_trustpilot_first_run_wizard %}
    <div class="ecocode-trustpilot-first-run-wizard">
        {% block ecocode_trustpilot_first_run_wizard_view_content %}
            <ecocode-trustpilot-first-run-wizard-modal></ecocode-trustpilot-first-run-wizard-modal>
        {% endblock %}
    </div>
{% endblock %}
